export const JOB_DETAILS = {
  "neuromorphic-ai-engineer": {
    description:
      "Design and develop neuromorphic and brain-inspired artificial intelligence systems that model biologically plausible learning and neural computation.",
    qualifications: [
      "Degree in Artificial Intelligence, Computer Science, or related field",
      "Strong understanding of neuromorphic computing principles",
      "Proficiency in Python and neural modeling frameworks"
    ],
    additionalQualifications: [
      "Experience with spiking neural networks",
      "Research or applied projects in brain-inspired AI"
    ],
    salary: "€55k–65k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "spiking-neural-network-engineer": {
    description:
      "Develop and evaluate spiking neural network models for event-driven and energy-efficient artificial intelligence.",
    qualifications: [
      "Degree in AI, Computer Science, or Computational Neuroscience",
      "Strong foundation in neural network theory",
      "Python programming experience"
    ],
    additionalQualifications: [
      "Knowledge of STDP or temporal learning rules",
      "Hands-on experimentation with SNN frameworks"
    ],
    salary: "€50k–60k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "brain-inspired-ai-systems-engineer": {
    description:
      "Build end-to-end AI systems inspired by biological intelligence, integrating learning, memory, and reasoning components.",
    qualifications: [
      "Degree in Artificial Intelligence or Computer Science",
      "Experience designing complex AI systems",
      "Strong software engineering skills"
    ],
    additionalQualifications: [
      "Exposure to cognitive or biologically inspired models",
      "Ability to translate research into systems"
    ],
    salary: "€60k–70k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "neural-architecture-engineer": {
    description:
      "Design advanced neural architectures optimized for scalability, adaptability, and efficient learning.",
    qualifications: [
      "Degree in AI, Computer Science, or related field",
      "Strong understanding of neural architecture design",
      "Experience with deep learning frameworks"
    ],
    additionalQualifications: [
      "Research in architecture exploration",
      "Knowledge of biologically inspired optimization"
    ],
    salary: "€65k–75k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },
  "neural-dynamics-learning-engineer": {
    description:
      "Design and analyze neural dynamics and biologically inspired learning mechanisms to ensure stability, adaptability, and efficient learning in artificial intelligence systems.",

    qualifications: [
      "Degree in Artificial Intelligence, Applied Mathematics, Computer Science, or related field",
      "Strong understanding of neural dynamics and learning processes",
      "Experience with neural simulations and mathematical modeling"
    ],

    additionalQualifications: [
      "Research background in learning theory or dynamical systems",
      "Experience analyzing stability and convergence of learning models"
    ],

    salary: "€55k–65k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "adaptive-continual-learning-engineer": {
    description:
      "Develop artificial intelligence systems capable of adaptive and continual learning while minimizing catastrophic forgetting across tasks and domains.",

    qualifications: [
      "Degree in Artificial Intelligence, Computer Science, or related field",
      "Strong understanding of machine learning and optimization algorithms",
      "Experience implementing adaptive or continual learning models"
    ],

    additionalQualifications: [
      "Research experience in lifelong or continual learning",
      "Familiarity with transfer learning or multi-task learning"
    ],

    salary: "€55k–65k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "cognitive-computing-engineer": {
    description:
      "Develop artificial intelligence systems that model cognition, reasoning, and decision-making.",
    qualifications: [
      "Degree in AI, Cognitive Science, or Computer Science",
      "Understanding of symbolic and learning-based AI",
      "Python programming skills"
    ],
    additionalQualifications: [
      "Experience with cognitive architectures",
      "Interest in human-like intelligence"
    ],
    salary: "€50k–60k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "neural-dynamics-learning-engineer": {
    description:
      "Research and implement neural dynamics and adaptive learning mechanisms for stable AI systems.",
    qualifications: [
      "Degree in AI, Applied Mathematics, or related field",
      "Strong understanding of learning dynamics",
      "Experience with neural simulations"
    ],
    additionalQualifications: [
      "Research background in learning theory",
      "Model stability analysis experience"
    ],
    salary: "€55k–65k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "hybrid-ai-systems-engineer": {
    description:
      "Design hybrid AI systems combining neural learning with structured and symbolic reasoning.",
    qualifications: [
      "Degree in Artificial Intelligence or Computer Science",
      "Experience with neural and rule-based systems",
      "Strong programming skills"
    ],
    additionalQualifications: [
      "System-level AI integration experience",
      "Research-driven mindset"
    ],
    salary: "€55k–65k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "neuro-symbolic-ai-engineer": {
    description:
      "Develop neuro-symbolic AI models integrating logical reasoning with neural learning.",
    qualifications: [
      "Degree in AI or Computer Science",
      "Understanding of symbolic reasoning and ML",
      "Python programming experience"
    ],
    additionalQualifications: [
      "Experience with knowledge graphs",
      "Research exposure in neuro-symbolic AI"
    ],
    salary: "€50k–60k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "general-artificial-intelligence-engineer": {
    description:
      "Work on AI systems designed for broad generalization, adaptability, and multi-task intelligence.",
    qualifications: [
      "Degree in AI or Computer Science",
      "Strong ML foundations",
      "Experience building complex AI models"
    ],
    additionalQualifications: [
      "Interest in general intelligence research",
      "Multi-task learning experience"
    ],
    salary: "€60k–70k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "adaptive-continual-learning-engineer": {
    description:
      "Develop AI models capable of continual learning without catastrophic forgetting.",
    qualifications: [
      "Degree in AI or Computer Science",
      "Understanding of learning algorithms",
      "Python and ML framework experience"
    ],
    additionalQualifications: [
      "Research in continual learning",
      "Adaptive system design experience"
    ],
    salary: "€55k–65k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "advanced-machine-intelligence-engineer": {
    description:
      "Design advanced machine intelligence systems focused on abstraction, reasoning, and robustness.",
    qualifications: [
      "Degree in Artificial Intelligence",
      "Strong AI system knowledge",
      "Experience implementing advanced models"
    ],
    additionalQualifications: [
      "High-impact AI projects",
      "Strong analytical thinking"
    ],
    salary: "€60k–70k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "neuromorphic-ai-research-scientist": {
    description:
      "Conduct original research in neuromorphic and brain-inspired artificial intelligence.",
    qualifications: [
      "Master’s or PhD in AI, Neuroscience, or related field",
      "Strong research background",
      "Scientific publication experience"
    ],
    additionalQualifications: [
      "Conference or journal publications",
      "Research mentorship experience"
    ],
    salary: "€75k–85k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "artificial-intelligence-research-engineer": {
    description:
      "Bridge AI research and engineering by implementing and scaling research ideas.",
    qualifications: [
      "Degree in AI or Computer Science",
      "Strong ML foundations",
      "Experience prototyping research models"
    ],
    additionalQualifications: [
      "Open-source or academic contributions",
      "Research-driven team experience"
    ],
    salary: "€60k–70k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "cognitive-systems-research-scientist": {
    description:
      "Research cognition-inspired AI systems focusing on reasoning, memory, and intelligence emergence.",
    qualifications: [
      "Master’s or PhD in AI or Cognitive Science",
      "Strong experimental research skills",
      "Experience in AI research"
    ],
    additionalQualifications: [
      "Publications in AI or cognitive science",
      "Interdisciplinary research experience"
    ],
    salary: "€70k–80k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "artificial-general-intelligence-researcher": {
    description:
      "Research foundational approaches toward general-purpose artificial intelligence.",
    qualifications: [
      "Advanced degree in Artificial Intelligence",
      "Strong theoretical and experimental knowledge",
      "Independent research capability"
    ],
    additionalQualifications: [
      "Frontier AI publications",
      "Long-term research vision"
    ],
    salary: "€80k–90k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "ai-systems-engineer": {
    description:
      "Design and maintain scalable AI systems supporting training, inference, and deployment.",
    qualifications: [
      "Degree in AI or Computer Science",
      "Experience with AI system pipelines",
      "Python and systems knowledge"
    ],
    additionalQualifications: [
      "Production AI deployment experience",
      "System reliability understanding"
    ],
    salary: "€55k–65k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "neural-model-optimization-engineer": {
    description:
      "Optimize neural models for performance, efficiency, and stability.",
    qualifications: [
      "Degree in AI or Computer Science",
      "Understanding of neural training and inference",
      "Experience with optimization techniques"
    ],
    additionalQualifications: [
      "Knowledge of pruning or quantization",
      "Performance analysis skills"
    ],
    salary: "€50k–60k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "scalable-ai-architecture-engineer": {
    description:
      "Design scalable AI architectures for large-model training and inference.",
    qualifications: [
      "Degree in AI or Computer Science",
      "Strong system architecture knowledge",
      "Experience with scalable AI systems"
    ],
    additionalQualifications: [
      "Distributed AI experience",
      "Research-to-production pipeline design"
    ],
    salary: "€60k–70k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "intelligent-systems-infrastructure-engineer": {
    description:
      "Build infrastructure enabling reliable AI experimentation and deployment.",
    qualifications: [
      "Degree in Computer Science or AI",
      "Understanding of AI infrastructure needs",
      "Strong systems programming skills"
    ],
    additionalQualifications: [
      "Experience supporting research environments",
      "Scalability and monitoring knowledge"
    ],
    salary: "€55k–65k PA + Perks",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom"
  },

  "neuromorphic-ai-intern": {
    description:
      "Support neuromorphic AI research and experimentation under senior mentorship.",
    qualifications: [
      "Student in AI or Computer Science",
      "Basic neural network knowledge",
      "Python programming skills"
    ],
    additionalQualifications: [
      "Interest in neuromorphic AI",
      "Academic AI projects"
    ],
    salary: "€1.2k–1.6k per month",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom / Remote"
  },

  "spiking-neural-networks-research-intern": {
    description:
      "Assist research on spiking neural networks and biologically inspired learning.",
    qualifications: [
      "Student in AI or related field",
      "Basic neural model understanding",
      "Python proficiency"
    ],
    additionalQualifications: [
      "Coursework in neuroscience",
      "Research curiosity"
    ],
    salary: "€1.2k–1.6k per month",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom / Remote"
  },

  "artificial-intelligence-research-intern": {
    description:
      "Assist AI researchers with experiments, evaluation, and analysis.",
    qualifications: [
      "AI or Computer Science student",
      "Foundational ML knowledge",
      "Python skills"
    ],
    additionalQualifications: [
      "Strong analytical thinking",
      "Academic research exposure"
    ],
    salary: "€1.3k–1.8k per month",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom / Remote"
  },

  "hybrid-ai-systems-intern": {
    description:
      "Support development of hybrid AI systems combining neural and symbolic approaches.",
    qualifications: [
      "Student in AI or Computer Science",
      "Basic ML understanding",
      "Python experience"
    ],
    additionalQualifications: [
      "Interest in hybrid intelligence",
      "System thinking"
    ],
    salary: "€1.2k–1.6k per month",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom / Remote"
  },

  "cognitive-ai-research-intern": {
    description:
      "Assist research into cognition-inspired artificial intelligence systems.",
    qualifications: [
      "Student in AI or Cognitive Science",
      "Basic AI understanding",
      "Python skills"
    ],
    additionalQualifications: [
      "Interest in cognitive modeling",
      "Research motivation"
    ],
    salary: "€1.2k–1.6k per month",
    workinghours: "40 hrs/week",
    location: "London, United Kingdom / Remote"
  }
};

